(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!window.__vyseraQuantityBundleSync) {
    window.__vyseraQuantityBundleSync = true;

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement) || !target.matches('[data-quantity-bundle-input]')) return;

      const bundle = target.closest('[data-quantity-bundle]');
      const form = bundle?.closest('form');
      const quantityInput = form?.querySelector('input[name="quantity"]');
      if (!bundle || !quantityInput) return;

      const quantity = target.value;
      const quantitySelector = quantityInput.closest('quantity-selector-component');

      if (typeof quantitySelector?.setValue === 'function') {
        quantitySelector.setValue(quantity);
      } else {
        quantityInput.value = quantity;
      }

      quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));

      if (typeof quantitySelector?.onQuantityChange === 'function') {
        quantitySelector.onQuantityChange();
      }
      if (typeof quantitySelector?.updateButtonStates === 'function') {
        quantitySelector.updateButtonStates();
      }

      bundle.querySelectorAll('[data-quantity-bundle-option]').forEach((option) => {
        option.classList.toggle('is-selected', option.contains(target));
      });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
